import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, first, switchMap, map } from 'rxjs/operators';
import { CompanyResource } from '@app/shared/modules/resources/company.resource';
import { IFBDomainInputMode, EFBDomainInputMode } from '../domain-input/domain-input.model';

export function domainExistsValidator(companyResource: CompanyResource, mode: IFBDomainInputMode): AsyncValidatorFn {
  const isSubdomain = mode === EFBDomainInputMode.SUBDOMAIN;
  return (ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    return ctrl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(value => (isSubdomain ? companyResource.getCompany(value) : companyResource.getMetadata(value))),
      map(() => null),
      catchError(() => of({ domainNotAvailable: true })),
      first()
    );
  };
}
